import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import { Dropdown, Option } from "./Dropdown";
import { Form, Button } from "react-bootstrap";
// import Form from "react-bootstrap/Form";
//import { createDevice } from "../services/createDevice";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import { environment } from "../../environment";
import { RadioGroup, Radio } from "@adobe/react-spectrum";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";

const MySwal = withReactContent(Swal);

const EditSubscriptions = ({ history, match }) => {
  const [users, setUsers] = useState([]);
  const [dap_name, setName] = useState("");
  const [dap_package, setPackage] = useState("");

  const [dap_price, setPrice] = useState("");
  const [dap_email, setEmail] = useState("");
  const [dap_phone, setPhone] = useState("");
  const [dap_userNo, setUserNo] = useState("");
  const [dap_billable, setBillable] = useState(false);
  // const [dap_billable1, setBillable1] = useState(false);
  // const [selected, setSelected] = useState(false);
  const [dap_address, setAddress] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [dap_countries, setDapCountries] = useState("");
  const [dap_states, setDapState] = useState([]);
  const [country, setCountry] = useState("");
  const [zip, setZip] = useState("");
  const [region, setRegion] = useState("");
  const [loading, setLoading] = useState(false);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [poststate, setPostState] = useState("");
  const [postcity, setPostCity] = useState("");
  const [emailErrors, setEmailErrors] = useState({});
  const [nameErrors, setNameErrors] = useState({});
  const [phoneErrors, setPhoneErrors] = useState({});
  const [priceErrors, setPriceErrors] = useState({});
  const dap_user_id = match.params.id;
  let roles = [];
  roles = [
    {
      roleType: "Basic",
      price: 1000,
    },
    {
      roleType: "Advance",
      price: 2000,
    },
    {
      roleType: "Corporate",
      price: 3000,
    },
  ];
  // let packageArr = [
  //   { "Basic": "1000" },
  //   { " package2": "2000" },
  //   { "package1": "3000" },
  // ];
  let countries = [];
  let states = [];
  countries = Country.getAllCountries();
  states = State.getAllStates();
  const selectCountry = (e) => {
    setDapCountries(Country.getAllCountries());
    setDapState(State.getStatesOfCountry(e.id));
    setCountryCode(e.id);
    setPostCountry(e.label);
  };

  const selectRegion = (e) => {
    setDapCity(City.getCitiesOfState(countrycode, e.id));
    setPostState(e.label);
  };
  const selectCity = (e) => {
    setPostCity(e.label);
  };

  // console.log(Country.getAllCountries());
  // console.log(Country.getAllCountries());
  // console.log(State.getAllStates());

  //   const Role = ({ dap_role, setRole }) => {
  //     const options = [{ logistic_manager }, { users }];
  //   };

  useEffect(() => {
    let id = match.params.id;
    //  console.log(id);getLead(id);
    console.log(history);
    console.log(id);
    axios
      .get(environment.dap_url + "crm_api/getSubscriberById?id=" + id)
      .then((res) => {
        const dap_users = res.data;
        console.log(res);
        console.log("hello");
        setUsers(res.data);
        setEmail(res.data.email);
        setName(res.data.name);
        setPhone(res.data.phone);
        setPackage(res.data.package);
        setPrice(res.data.price);
        setUserNo(res.data.userNumber);

        setPostCountry(res.data.country);
        setPostState(res.data.state);
        setPostCity(res.data.city);

        console.log(res.data);
        // setLoader(false);
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  }, []);

  const formValidation = () => {
    const emailErrors = {};
    const nameErrors = {};
    const phoneErrors = {};
    const priceErrors = {};

    let isValid = true;

    if (!dap_email) {
      emailErrors.noEmail = "* Email Id required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(dap_email)) {
      emailErrors.invalidEmail = "* Email address is invalid";
      isValid = false;
    }
    if (!dap_name) {
      nameErrors.noName = "* Name is required";
      isValid = false;
    } else if (dap_name.trim().length < 2) {
      nameErrors.shortName = "* First Name is too short";
      isValid = false;
    }
    if (!dap_price) {
      priceErrors.noPrice = "* price field is required";
      isValid = false;
    }
    if (!dap_phone) {
      phoneErrors.shortNumber = "* Phone number required";
      isValid = false;
    } else if (dap_phone.trim().length < 10) {
      phoneErrors.shortNumber = "* Phone number should be 10 digits";
      isValid = false;
    } else if (dap_phone.trim().length > 10) {
      phoneErrors.shortNumber = "* Phone number should be 10 digits";
      isValid = false;
    } else if (
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,1024}$/.test(
        dap_phone
      )
    ) {
      phoneErrors.shortNumber = "Phone number should be 10 digits";
      isValid = false;
    }

    setEmailErrors(emailErrors);
    setNameErrors(nameErrors);
    setPhoneErrors(phoneErrors);
    return isValid;
  };
  // const handlechange = (e) => {
  //   setBillable(!dap_billable);
  // };
  // const handlechange1 = (e) => {
  //   setBillable1(!dap_billable1);
  // };

  const submitHandler = (e) => {
    const isValid = formValidation();
    e.preventDefault();
    setLoading(true);
    let id1 = match.params.id;
    console.log(id1);
    axios
      .put(
        //"user?sendActivationMail=true",
        environment.dap_url + "crm_api/updateSubscriber?id=" + id1,
        {
          // id: match.params.id,
          //   name: dap_name,
          //   email: dap_email,
          //   phone: dap_phone,
          package: dap_package,
          price: dap_price,
          //   userType: "LOGISTIC_MANAGER",
        }
      )
      .then((res) => {
        console.log("hello", res.data);
        history.push("/subscriptions");
        MySwal.fire({
          title: <p>Subscriber has been successfully updated!</p>,
          type: "success",
        });
        //   history.push(`/users/${dap_user_id}`);
      })
      .catch((err) => {
        setLoading(false);
        MySwal.fire({
          title: (
            <p>{err?.response?.data?.message || "Subscriber update failed"}</p>
          ),
          type: "error",
        });
      });
  };
  const onChangeHandler = (e) => {
    setPackage(e.label);
    console.log(e);
    roles.forEach((element) => {
      if (e.value == element.roleType) {
        console.log(element.price);
        setPrice(element.price);
      }
    });
  };

  //   useEffect(() => {}, []);

  return (
    <div>
      <div className="row" style={{ marginTop: "75px", color: "black" }}></div>

      <div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Add Subscriber :</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginLeft: "4%", marginRight: "4%" }}>
        <Form onSubmit={submitHandler}>
          <div className="row">
            <div className="col-4">
              <Form.Group controlId="name">
                <Form.Label>* Name</Form.Label>
                <Form.Control
                  type="title"
                  placeholder="Name"
                  value={dap_name}
                  onChange={(e) => setName(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(nameErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{nameErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>

            <div className="col-4">
              <Form.Group controlId="name">
                <Form.Label> Package</Form.Label>
                <Select
                  options={roles.map((element) => ({
                    id: element.roleType,
                    value: element.roleType,
                    label: element.roleType,
                  }))}
                  // value={dap_role}
                  onChange={(e) => onChangeHandler(e)}
                  placeholder="Choose Package "
                  value={{
                    id: "",
                    label: dap_package,
                    value: dap_package,
                  }}
                />
                {/* <Form.Control
                  type="title"
                  placeholder="Package"
                  value={dap_package}
                  onChange={(e) => setPackage(e.target.value)}
                ></Form.Control> */}
                {/* <div>
                  {Object.keys(nameErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{nameErrors[key]}</div>
                    );
                  })}
                </div> */}
              </Form.Group>
            </div>

            <div className="col-4">
              <Form.Group controlId="name">
                <Form.Label>* Price</Form.Label>
                {/* <Select
                  options={roles.map((element) => ({
                    id: element.roleType,
                    value: element.package,
                    label: element.package,
                  }))}
                  // value={dap_role}
                  onChange={(e) => setPackage(e)}
                  // placeholder="Choose Package "
                /> */}
                <Form.Control
                  type="title"
                  placeholder="Price"
                  value={dap_price}
                  // onChange={(e) => setPrice(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(priceErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{priceErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-4">
              <Form.Group controlId="name">
                <Form.Label>* Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={dap_email}
                  onChange={(e) => setEmail(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(emailErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{emailErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-4">
              <Form.Group controlId="role">
                <Form.Label>* Phone</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Phone"
                  value={dap_phone}
                  onChange={(e) => setPhone(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(phoneErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{phoneErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-4">
              <Form.Group controlId="name">
                <Form.Label>User No </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="User Number"
                  value={dap_userNo}
                  onChange={(e) => setUserNo(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <Form.Group controlId="name">
                <Form.Label>Country</Form.Label>
                <Select
                  options={countries.map((element) => ({
                    id: element.isoCode,
                    value: element.name,
                    label: element.name,
                  }))}
                  onChange={(e) => selectCountry(e)}
                  // defaultValue={dap_deviceList[0].name}
                  defaultValue="hi there"
                  placeholder="Country"
                  value={{
                    id: "",
                    label: postcountry,
                    value: postcountry,
                  }}
                />
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="name">
                <Form.Label>State</Form.Label>
                <Select
                  options={dap_states.map((element) => ({
                    id: element.isoCode,
                    value: element.name,
                    label: element.name,
                  }))}
                  onChange={(e) => selectRegion(e)}
                  // defaultValue={dap_deviceList[0].name}
                  defaultValue="hi there"
                  placeholder="State"
                  value={{ label: poststate, value: poststate }}
                />
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="name">
                <Form.Label>City</Form.Label>
                <Select
                  options={dap_city.map((element) => ({
                    id: element.isoCode,
                    value: element.name,
                    label: element.name,
                  }))}
                  onChange={(e) => selectCity(e)}
                  // defaultValue={dap_deviceList[0].name}
                  defaultValue="hi there"
                  placeholder="City"
                  value={{ label: postcity, value: postcity }}
                />
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="zip">
                <Form.Label>Zip</Form.Label>
                <Form.Control
                  type="zip"
                  placeholder="Enter postal code"
                  value={zip}
                  onChange={(e) => setZip(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <Form.Group controlId="address">
                <Form.Label> Address</Form.Label>
                <Form.Control
                  style={{ height: "8%" }}
                  placeholder="Address"
                  value={dap_address}
                  onChange={(e) => setAddress(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </div>

            {/* <div className="col-3">
              <Form.Group controlId="address">
                <Form.Label> Features</Form.Label>
                <div>
                  <input
                    name="yes"
                    type="checkbox"
                    value={true}
                    // value={dap_billable}
                    checked={dap_billable}
                    // onFocus
                    onChange={(e) => handlechange_new(e)}
                    style={{ marginTop: 24 }}
                  />
                  {""}
                  Features
                </div>
                <div>
                  <input
                    name="no"
                    type="checkbox"
                    value={false}
                    onChange={(e) => handlechange_new(e)}
                    style={{ marginTop: 24 }}
                  />
                  {""}
                  Features
                </div>
                <div>
                  <input
                    name="no"
                    type="checkbox"
                    value={false}
                    // value={dap_billable}
                    // checked={dap_billable}
                    onChange={(e) => handlechange_new(e)}
                    style={{ marginTop: 24 }}
                  />
                  {""}
                  Features
                </div>
              </Form.Group>
            </div> */}
            <div className="col-3" style={{ marginTop: "2%" }}>
              <button type="submit" class="btn btn-primary" disabled={loading}>
                SAVE
                {loading && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                {loading && <span></span>}
                {!loading && <span></span>}
              </button>
              <button type="button" class="btn btn-danger">
                <Link to="/subscriptions" style={{ color: "white" }}>
                  CANCEL
                </Link>
              </button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default EditSubscriptions;
